import { render, staticRenderFns } from "./issues.vue?vue&type=template&id=080a191c&scoped=true&lang=pug&"
import script from "./issues.vue?vue&type=script&setup=true&lang=js&"
export * from "./issues.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./issues.vue?vue&type=style&index=0&id=080a191c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080a191c",
  null
  
)

export default component.exports